/* eslint-disable @typescript-eslint/no-explicit-any */
import { TableRow } from "../shared";

interface StickyTableBodyProps {
  rows: any[];
  prepareRow: (row: any) => void;
  getTableBodyProps: () => any;
  isShowDecoratorColor: boolean;
  showConfigColumn: boolean;
  onRenderConfig?: (original: any) => React.ReactNode;
  isGroupedMode: boolean;
  // Filter props
  isDisabbledAddFilter: boolean;
  restrictedFilters?: string[];
  filterVisibleKeys?: string[];
  filterMap?: Record<string, unknown>;
  onFilterClicked?: (
    action: string,
    columnKey: string,
    filterKeys: string[],
    cellValue: any[] | null
  ) => void;
}

export const StickyTableBody = ({
  rows,
  prepareRow,
  getTableBodyProps,
  isShowDecoratorColor,
  showConfigColumn,
  onRenderConfig,
  isGroupedMode,
  isDisabbledAddFilter,
  restrictedFilters,
  filterVisibleKeys,
  filterMap,
  onFilterClicked,
}: StickyTableBodyProps) => {
  return (
    <div className="tbody" {...getTableBodyProps()}>
      {rows.map((row: any, i: number) => (
        <TableRow
          key={row.id ?? i}
          row={row}
          rowIndex={i}
          prepareRow={prepareRow}
          isShowDecoratorColor={isShowDecoratorColor}
          showConfigColumn={showConfigColumn}
          onRenderConfig={onRenderConfig}
          isGroupedMode={isGroupedMode}
          isDisabbledAddFilter={isDisabbledAddFilter}
          restrictedFilters={restrictedFilters}
          filterVisibleKeys={filterVisibleKeys}
          filterMap={filterMap}
          onFilterClicked={onFilterClicked}
        />
      ))}
    </div>
  );
};
